__webpack_require__.p = "/wp-content/themes/em-brand-insight-report/dist/";